<template>
    <div>
        <div class="row justify-content-center mb-4">
            <h4><b>{{round.RoundName}}</b></h4>
            <p class="mb-0 olympics-round-text">{{RoundFunctions.getDayOfWeek(round.RoundStartDate)}} {{RoundFunctions.getDay(round.RoundEndDate)}} {{ RoundFunctions.getMonth(round.RoundStartDate) }} {{ RoundFunctions.getYear(round.RoundStartDate) }}</p>
            <p class="olympics-round-text">STARTS: {{ RoundFunctions.getTime(round.RoundStartDate) }} | CLOSES: {{ RoundFunctions.getTime(round.RoundEndDate) }}</p>
            <div class="col-9 col-md-4 round-container-olympics" v-on:click="RoundFunctions.onRoundClicked(round, selectedSport)">
                {{RoundFunctions.getOlympicsButtonText(round.HasPredictions)}}
            </div>
        </div>
        <hr class="line-break">
    </div>
</template>

<script>
    import RoundFunctions from "../functions/roundFunctions";
    import {mapState} from "vuex";

    export default {
        name: "OlympicsRound",
        props: {
            round: {
                type: Object
            },
        },
        data() {
            return {
                RoundFunctions: RoundFunctions,
            }
        },
        computed: mapState(['selectedSport', 'sportsWithActiveRounds', 'selectedLeague']),
    }
</script>

<style scoped lang="scss">

    .round-container-olympics {
        color: $round-container-background-color;
        padding: 1rem 0;
        background-color: $round-details-text-color;
        border-radius: 5px;
    }

    .olympics-round-text {
        font-size: large;
    }

    @media screen and (max-width: 900px)  {
        .olympics-round-text {
            font-size: medium;
        }
    }
</style>
